import React from 'react'

const ChevronUp = () => (
    <svg width="16" height="9" viewBox="0 0 16 9" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path id="Vector" d="M2.10184 8.99037C1.02784 8.99037 0.453844 7.72637 1.16184 6.91737L6.68284 0.607372C6.8471 0.419657 7.04958 0.269223 7.27672 0.166155C7.50386 0.0630866 7.75041 0.00976562 7.99984 0.00976562C8.24928 0.00976563 8.49583 0.0630866 8.72297 0.166155C8.95011 0.269223 9.15259 0.419657 9.31684 0.607372L14.8388 6.91737C15.5458 7.72637 14.9718 8.99037 13.8988 8.99037H2.10084H2.10184Z" fill="#212121" />
    </svg>
)

export default ChevronUp
